(() => {
  const formatMoney = (cents, node) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.money_format || node.dataset.moneyFormat);
    }
    return `${(cents / 100).toFixed(2)} ${node.dataset.currencyCode || ''}`.trim();
  };

  const updateSubtotal = (node, cents) => {
    if (!node || !Number.isFinite(cents)) return;
    const quantity = Math.max(1, Number(node.closest('product-form-component')?.querySelector('.quantity__input')?.value) || 1);
    const price = node.querySelector('[data-subtotal-price]');
    if (price) price.textContent = formatMoney(cents * quantity, node);
  };

  const bindQuantityUpdates = (productInfo, subtotal, state) => {
    if (state.bound) return;
    state.bound = true;
    const quantity = productInfo.querySelector('.quantity__input');
    const refresh = () => updateSubtotal(subtotal, state.cents);
    quantity?.addEventListener('input', refresh);
    quantity?.addEventListener('change', refresh);
    if (quantity) {
      let lastQuantity = quantity.value;
      window.setInterval(() => {
        if (quantity.value === lastQuantity) return;
        lastQuantity = quantity.value;
        refresh();
      }, 250);
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
  };

  const handleVariantChange = ({ data }) => {
    const productInfo = document.querySelector(`product-info[data-section="${data.sectionId}"]`);
    const subtotal = productInfo?.querySelector('[data-product-subtotal]');
    if (!subtotal || !data.variant || !Number.isFinite(Number(data.variant.price))) return;

    // The AJAX response contains the market-specific subtotal data. Replace the stale JSON
    // before updating the visible amount so later quantity changes use the same price.
    const source = data.html?.querySelector('[data-product-subtotal]');
    if (source) subtotal.innerHTML = source.innerHTML;
    const state = productInfo.__marketSubtotalState || { bound: false, cents: 0 };
    state.cents = Number(data.variant.price);
    productInfo.__marketSubtotalState = state;
    updateSubtotal(subtotal, state.cents);
    bindQuantityUpdates(productInfo, subtotal, state);
  };

  const bind = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    if (window.__marketSubtotalFixBound) return;
    window.__marketSubtotalFixBound = true;
    subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
    document.querySelectorAll('product-info').forEach((productInfo) => {
      const subtotal = productInfo.querySelector('[data-product-subtotal]');
      const variantsNode = subtotal?.querySelector('[data-subtotal-variants]');
      const variantInput = productInfo.querySelector('input[name="id"]');
      if (!subtotal || !variantsNode || !variantInput) return;
      let variants = [];
      try {
        variants = JSON.parse(variantsNode.textContent || '[]');
      } catch {
        return;
      }
      const variant = variants.find((item) => String(item.id) === String(variantInput.value));
      if (!variant || !Number.isFinite(Number(variant.price))) return;
      const state = { bound: false, cents: Number(variant.price) };
      productInfo.__marketSubtotalState = state;
      updateSubtotal(subtotal, state.cents);
      bindQuantityUpdates(productInfo, subtotal, state);
    });
  };

  bind();
  document.addEventListener('product-info:loaded', bind);
})();
